import LineShare from '../type/line'
import PieShare from '../type/pie'
import BarAndLineShare from '../type/barAndLine'
import BarShare from '../type/bar'
import GaugeShare from '../type/gauge'
import  PictorialBar from '../type/pictorialBar'
import Polar from '../type/polar'
//import  PictorialBarAndLine from '../type/pictorialBarAndLine'

// 工厂设计模式  根据不同的图标类型来生产出自适应的 option
let Factory = function (type, dataList) {
  if (this instanceof Factory) { // new Factory() 执行
    this.option = {}
    return new this[type](type, dataList)
  } else {
    return new Factory(type, type, dataList) // Factory()
  }
}
Factory.prototype = {
  //折线图
  'line': function (type, dataList) {
    let line = new LineShare(dataList, type)
    this.option = line.option
  },
  //饼图
  'pie': function (type, dataList) {
    let pie = new PieShare(dataList, type)
    this.option = pie.option
  },
  //柱状和折线图
  'barAndline': function (type, dataList) {
    let barAndLine = new BarAndLineShare(dataList, type)
    this.option = barAndLine.option;
    //console.log(JSON.stringify(this.option),'barAndline========= ')
  },
  //柱状图
  'bar': function (type, dataList) {
    var bar = new BarShare(dataList, type)
    this.option = bar.option
  },
  //仪表盘
  'gauge': function (type, dataList) {
    let g = new GaugeShare(dataList, type)
    this.option = g.option;

  },
  'polar':function(type, dataList){
    let p = new Polar(dataList, type)
    this.option = p.option;
  },
  //PictorialBar
  'pictorialBar': function (type, dataList) {
    let p = new PictorialBar(dataList, type)
    this.option = p.option;
  }
}

export default Factory
